import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, Input } from '@safedns/skydns-ui-react-lib';

import useValidateDomain from '../../hooks/useValidateDomain';
import { notificationSuccess } from '../../store/notificationReducer';

import { useGetUserQuery, useUpdateDomainMutation } from '../../services/ADapi';
import styles from './DomainForm.module.scss';

const UpdateDomain = ({ domainId, domainName, isClosed, onClose }) => {
  const dispatch = useDispatch();

  const {
    data: { user_id },
  } = useGetUserQuery();

  const {
    name,
    nameIsBlur,
    nameError,
    formIsValid,
    formIsSuccess,
    nameHandler,
    blurHandler,
    setName,
    setNameError,
    setFormIsValid,
    setFormIsSuccess,
  } = useValidateDomain();

  const notification = {
    isNotification: true,
    type: 'success',
    action: 'update_domain',
    message: `${domainName} переименован`,
  };

  const [updateDomain] = useUpdateDomainMutation();

  useEffect(() => {
    setName(domainName);
  }, [domainName, setName]);

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      await updateDomain({
        user_id,
        id: domainId,
        payload: { name },
      });
    } catch (error) {
      console.error(error);
    }

    onClose();

    dispatch(notificationSuccess(notification));

    setFormIsSuccess(!formIsSuccess);
    setFormIsValid(false);

    setName('');
    setNameError('');
  };

  return (
    <Modal
      isOpen={isClosed}
      onClose={onClose}
      title="Изменение названия"
      sx={{ maxWidth: 500 }}
    >
      <form className={styles['modal-form']} onSubmit={submitForm}>
        <Input
          id="domainName"
          label="Введите новое название:"
          value={name}
          size="medium"
          onBlur={blurHandler}
          onChange={nameHandler}
        />
        {nameIsBlur && nameError && (
          <span className="validate-error" style={{ marginTop: -24 }}>
            {nameError}
          </span>
        )}
        <div className={styles['button-group']}>
          <Button variant="secondary" onClick={onClose} width="100%">
            Отмена
          </Button>
          <Button
            variant="primary"
            type="submit"
            isDisabled={!formIsValid}
            width="100%"
          >
            Сохранить
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateDomain;
